<h1 mat-dialog-title i18n>Delete User <small class="align-top">- {{dialogData.user.email}}</small></h1>

<form (ngSubmit)="onFormSubmit()">
	<div mat-dialog-content class="main-content">
		<div class="row">
			<div class="col-12 mb-4">
				<p i18n>Use the selected app key to delete the user. This action will remove the user account and cannot be undone.</p>
			</div>
		</div>
	</div>

	<div mat-dialog-actions class="row mb-0">
		<div class="col-6 text-center">
			<button
				class="w-100"
				mat-flat-button
				mat-dialog-close
				i18n
			>Cancel</button>
		</div>
		<div class="col-6 text-center">
			<button
				class="w-100"
				type="submit"
				mat-flat-button
				color="primary"
				i18n
				cdkFocusInitial
			>Ok</button>
		</div>
	</div>
</form>
